export default __webpack_public_path__ + "static/media/checkers-4-lqMAX.76ff3bf1.jpg";